import { useAuth } from '../../new/providers/authentication-provider';
import { useEffect } from 'react';
import { useToast } from '@shadcn/ui/hooks/use-toast';
import { LoaderView } from '../../new/components/loader';
import { useAnalyticsReady } from '../../new/hooks/use-analytics';

// This is the gatekeeper for the app. It will block the app from loading until the auth and analytics are ready.
// It will also show a toast if the auth or analytics are not ready.
// All providers below this component are dependent on the auth and analytics being ready.

export function BlockingLoader({ children }: { children: React.ReactNode }) {
    const { isAuthReady } = useAuth();
    const { isAnalyticsReady } = useAnalyticsReady();
    const { toast } = useToast();

    const toastIt = () => {
        toast({
            variant: 'warning',
            title: 'Loading seems slower than normal',
            description: (
                <>
                    <p className="mb-2">Get faster loading by clearing your cookies.</p>
                    <small>
                        <b>Example (Chrome):</b>
                        <br />
                        1. Click the <span className="font-medium">Lock (🔒)</span> in the address bar
                        <br />
                        2. Click <span className="font-medium">Cookies and site data</span>
                        <br />
                        3. Click <span className="font-medium">Manage on-device site data</span>
                        <br />
                        4. Click the <span className="font-medium">Trash (🗑️)</span> icon next to andsend.com
                        <br />
                        5. Done
                    </small>
                </>
            ),
            duration: 3 * 60 * 1000,
        });
    };

    // useEffect(() => {
    //     let timeoutId: ReturnType<typeof setTimeout> | null = null;
    //     let authBecameReady = false;

    //     const markAuthReady = () => {
    //         if (timeoutId) {
    //             clearTimeout(timeoutId);
    //         }
    //     };

    //     if (isAuthReady) {
    //         markAuthReady();
    //     } else {
    //         timeoutId = setTimeout(() => {
    //             console.log('status', { isAuthReady, authBecameReady });
    //             if (!isAuthReady) {
    //                 console.warn('Firebase auth loading took longer than 7 seconds.');
    //                 toastIt();
    //             }
    //         }, 7000);
    //     }

    //     return () => {
    //         if (timeoutId) {
    //             clearTimeout(timeoutId);
    //         }
    //     };
    // }, [toast, isAuthReady]);

    // useEffect(() => {
    //     let timeoutId: ReturnType<typeof setTimeout> | null = null;

    //     const markAnalyticsReady = () => {
    //         if (timeoutId) {
    //             clearTimeout(timeoutId);
    //         }
    //     };

    //     if (isAuthReady) {
    //         markAnalyticsReady();
    //     } else {
    //         timeoutId = setTimeout(() => {
    //             if (!isAnalyticsReady) {
    //                 console.warn('Analytics loading took longer than 7 seconds.');
    //                 toastIt();
    //             }
    //         }, 7000);
    //     }

    //     return () => {
    //         if (timeoutId) {
    //             clearTimeout(timeoutId);
    //         }
    //     };
    // }, [toast, isAnalyticsReady]);

    if (!isAnalyticsReady) {
        console.log('Analytics not ready');
        return null;
    }
    console.log('Analytics is ready');

    if (!isAuthReady) {
        console.log('Auth not ready');
        return null;
    }
    console.log('Auth is ready');

    return isAuthReady && isAnalyticsReady ? children : <LoaderView />;
}
